import { useEffect, useId, useRef, type FormEvent } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../ui/Button";
import type { Scenes } from "./useScenes";

/** "Run Evening irrigation now?" before a scene runs (P-231, WEB-SCN-02); only Run sends. */
export function SceneDialog({ scenes, nameOf }: { scenes: Scenes; nameOf: (id: string) => string }) {
  const { t } = useTranslation();
  const dialog = useRef<HTMLDialogElement>(null);
  const titleId = useId();
  const { asking, closeAsking, run } = scenes;

  useEffect(() => {
    const d = dialog.current;
    if (!d) return;
    if (asking && !d.open) d.showModal();
    else if (!asking && d.open) d.close();
  }, [asking]);

  function submit(e: FormEvent) {
    e.preventDefault();
    if (asking) void run(asking);
    closeAsking();
  }

  return (
    <dialog
      ref={dialog}
      onClose={closeAsking}
      aria-labelledby={titleId}
      className="m-auto w-full max-w-md rounded-lg p-0 shadow-xl backdrop:bg-black/40"
    >
      {asking && (
        <form onSubmit={submit} className="p-6">
          <h2 id={titleId} className="text-lg font-semibold text-gray-900">
            {t("scenes.confirm.title", { name: nameOf(asking) })}
          </h2>
          <p className="mt-3 text-sm text-gray-900">{t("scenes.confirm.text")}</p>
          <div className="mt-6 flex justify-end gap-2">
            <Button variant="secondary" onClick={closeAsking}>
              {t("common.cancel")}
            </Button>
            <Button type="submit">{t("scenes.confirm.go")}</Button>
          </div>
        </form>
      )}
    </dialog>
  );
}
